import TotalSunContainer from "./TotalSunContainer";

export default TotalSunContainer;
